<template>
  <span
    class="default-user-avatar"
    :class="[`is-${size}`, { 'is-member': member, 'has-image': !!src }]"
    role="img"
    :aria-label="ariaLabel"
  >
    <img v-if="src" :src="src" alt="" class="avatar-image" />
    <svg v-else viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M512 946.858667c-239.616 0-434.858667-195.242667-434.858667-434.858667S272.384 77.141333 512 77.141333s434.858667 195.242667 434.858667 434.858667-195.242667 434.858667-434.858667 434.858667z m0-828.757334c-217.088 0-393.898667 176.810667-393.898667 393.898667 0 217.088 176.810667 393.898667 393.898667 393.898667 217.088 0 393.898667-176.810667 393.898667-393.898667 0-217.088-176.810667-393.898667-393.898667-393.898667z"
        fill="currentColor"
      />
      <path
        d="M509.952 615.082667c-106.496 0-193.194667-86.698667-193.194667-193.194667s86.698667-193.194667 193.194667-193.194667c106.496 0 193.194667 86.698667 193.194667 193.194667S616.448 615.082667 509.952 615.082667z m0-345.429334c-83.968 0-152.234667 68.266667-152.234667 152.234667s68.266667 152.234667 152.234667 152.234667S662.186667 505.856 662.186667 421.888 593.92 269.653333 509.952 269.653333z"
        fill="currentColor"
      />
      <path
        d="M512 946.858667c-111.957333 0-219.136-43.008-300.373333-120.149334l-8.874667-8.192 3.413333-11.605333c37.546667-136.533333 162.474667-232.106667 303.786667-232.106667 143.36 0 268.288 96.938667 304.469333 234.837334l2.730667 11.605333-8.874667 8.192c-79.872 75.776-185.002667 117.418667-296.277333 117.418667zM249.173333 805.546667c72.362667 64.853333 165.205333 100.352 262.826667 100.352 96.256 0 187.733333-34.816 259.413333-98.304-34.816-114.005333-140.629333-192.512-261.461333-192.512-118.784 0-224.597333 77.824-260.778667 190.464z"
        fill="currentColor"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'DefaultUserAvatar',
  props: {
    size: {
      type: String,
      default: 'md',
      validator: value => ['sm', 'md', 'lg'].includes(value)
    },
    member: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ''
    },
    ariaLabel: {
      type: String,
      default: '用户头像'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.default-user-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
  background: #f1f5f9;
  color: #6b6c6b;
  overflow: hidden;
  transition: box-shadow 0.25s ease, border-color 0.25s ease;

  svg {
    width: 78%;
    height: 78%;
    display: block;
  }

  .avatar-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  &.has-image {
    background: $bg-gray;
  }

  &.is-sm {
    width: 32px;
    height: 32px;
  }

  &.is-md {
    width: 52px;
    height: 52px;
    border: 3px solid rgba(255, 255, 255, 0.85);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &.is-lg {
    width: 80px;
    height: 80px;
    background: #fff;
    border: 2px solid $border-color;
    box-shadow: $shadow-sm;
  }

  &.is-member {
    border-color: #fcd34d;
    box-shadow: 0 2px 10px rgba(245, 158, 11, 0.35);

    &.is-md {
      border-color: rgba(255, 255, 255, 0.9);
      box-shadow: 0 4px 14px rgba(245, 158, 11, 0.45);
    }
  }
}
</style>
